import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar'
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip'
import { useTranslation } from 'react-i18next'
import { usePresence } from '@/lib/collab/presence-context'

export function TeamAvatarStack() {
  const { onlineUsers, followUser } = usePresence()
  const { t } = useTranslation()

  if (onlineUsers.length === 0) return null

  const visible = onlineUsers.slice(0, 5)
  const overflow = onlineUsers.length - visible.length

  return (
    <TooltipProvider delayDuration={200}>
      <div className="flex items-center -space-x-2">
        {visible.map((user) => (
          <Tooltip key={user.userId}>
            <TooltipTrigger asChild>
              <Avatar
                className="h-8 w-8 border-2 border-background cursor-pointer hover:opacity-80 transition-opacity"
                style={{ borderColor: user.color }}
                onClick={() => followUser(user.userId)}
              >
                {user.avatarUrl && <AvatarImage src={user.avatarUrl} alt={user.name} />}
                <AvatarFallback className="text-xs">
                  {user.name
                    .split(' ')
                    .map((w) => w[0])
                    .join('')
                    .slice(0, 2)
                    .toUpperCase()}
                </AvatarFallback>
              </Avatar>
            </TooltipTrigger>
            <TooltipContent>
              <p className="font-medium">{user.name}</p>
              {user.currentRouteKey && (
                <p className="text-xs text-muted-foreground">{t(`nav.${user.currentRouteKey}`)}</p>
              )}
            </TooltipContent>
          </Tooltip>
        ))}
        {overflow > 0 && (
          <div className="h-8 w-8 rounded-full bg-muted border-2 border-background flex items-center justify-center">
            <span className="text-xs font-medium text-muted-foreground">+{overflow}</span>
          </div>
        )}
      </div>
    </TooltipProvider>
  )
}
